/** Canonical Statsig gate names for the Operations feature area. */
export const OPERATIONS_FEATURE_FLAGS = {
  AI_VISION_WASTE_ENABLED: 'aivision-waste-enabled',
  AI_VISION_WASTE_SVC_VERIFICATION_ENABLED: 'aivision-waste-svc-verification-enabled',
  AI_VISION_WASTE_EVENTS_ENABLED: 'aivision-waste-events-enabled',
  AI_VISION_WASTE_OOC_ENABLED: 'aivision-waste-ooc-enabled',
  AI_VISION_WASTE_OOC_VIDEO_SEARCH_ENABLED: 'aivision-waste-ooc-video-search-enabled',
  PRODUCT_REGISTRY_ENABLED: 'aivision-product-registry-enabled',
} as const;

export type OperationsFeatureFlag = (typeof OPERATIONS_FEATURE_FLAGS)[keyof typeof OPERATIONS_FEATURE_FLAGS];
